export default "__VITE_ASSET__26b9ad8e__"